import { Capacitor } from '@capacitor/core';

/** True when playback routes through the native Capacitor audio plugin (Android only). */
export const isNativeAndroidAudio = Capacitor.getPlatform() === 'android';
